export interface TimeState {
  hours: string
  minutes: string
  amPm: string
}

export const getCurrentTime = (): TimeState => {
  if (typeof window === 'undefined') {
    return {
      hours: '--',
      minutes: '--',
      amPm: ''
    }
  }

  const formatter = new Intl.DateTimeFormat('de-DE', {
    timeZone: 'Europe/Berlin',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false
  })

  const date = new Date()
  const formattedTime = formatter.format(date)
  const [hours, minutes] = formattedTime.split(':')

  return {
    hours: hours.padStart(2, '0'),
    minutes: minutes.padStart(2, '0'),
    amPm: ''
  }
}
